import { Pipe, PipeTransform } from '@angular/core';
import { IconLibraryTypes } from '@liberty-financial/ng-components/lib/components/icon/library.enum';

import { OpportunityType } from '@shared/models/opportunity';
/*
 * Convert opportunity type to svg icons.
 * Usage:
 *   opportunityType | opportunityIcon
 * @example
 * // returns doc icon
 * {{ 'doc' | opportunityIcon }}
 */
@Pipe({
  name: 'opportunityIcon'
})
export class OpportunityIconPipe implements PipeTransform {
  transform(opportunityType: OpportunityType): IconLibraryTypes {
    switch (opportunityType) {
      case 'Car':
        return 'car';
      case 'Home':
        return 'house';
      case 'Personal':
        return 'palm';
      case 'SMSF':
        return 'donate';
      case 'Insurance':
        return 'handshake';
      case 'Refix':
        return 'transfer';
      case 'Commercial':
        return 'building';
    }
  }
}
